// app/javascript/controllers/license_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "form",
    "instructions",
    "monthAndYearSelector",
    "calendarControl"
  ];

  connect() {
    // When this controller loads, nothing happens automatically.
    // The lazy-load controller will fetch the license JSON and call load().
    this.element.addEventListener("lazy-load:loaded", (event) => {
      this.load(event);
    });
  }

  //
  // ENTRY POINT USED BY lazy-load CONTROLLER
  //
  load(event) {
    const json = event.detail;

    this.updateDom(json);
  }

  //
  // GENERIC FETCHER FOR PREVIOUS / NEXT MONTH LINKS
  //
  loadFromUrl(url) {
    fetch(url, {
      headers: {
        Accept: "application/json"
      }
    })
      .then(response => response.json())
      .then(json => this.updateDom(json))
      .catch(error => console.error("License calendar fetch failed:", error));
  }

  //
  // UPDATE THE DOM FROM A LICENSE JSON PAYLOAD
  //
  updateDom(json) {
    this.instructionsTarget.innerHTML = json.instructions;
    this.monthAndYearSelectorTarget.innerHTML = json.month_and_year_selector;
    this.calendarControlTarget.innerHTML = json.calendar_control;

    // Store URLs for use by event handlers
    this.previousMonthUrl = json.previous_month_url;
    this.nextMonthUrl = json.next_month_url;
  }

  //
  // CLICK HANDLERS (CALLED FROM ERB)
  //
  previousMonth(event) {
    event.preventDefault();
    if (this.previousMonthUrl) {
      this.loadFromUrl(this.previousMonthUrl);
    }
  }

  nextMonth(event) {
    event.preventDefault();
    if (this.nextMonthUrl) {
      this.loadFromUrl(this.nextMonthUrl);
    }
  }

  submit(event) {
    event.preventDefault();
    const form = this.formTarget;
    const params = new URLSearchParams(new FormData(form)).toString();
    fetch(`${form.action}?${params}`, {
      method: "GET",
      headers: { "Accept": "application/json" }
    })
    .then(response => response.json())
    .then(data => this.updateDom(data))
    .catch(error => console.error("Error loading updated calendar control:", error));
  }
}
